import styled from 'styled-components'
import { BaseInput } from 'components/Inputs/Base'
import { LookButton, iconButtonLook } from 'components/Buttons/look'
import { NumericFormat } from 'react-number-format'

export const Container = styled.div`
  background-color: ${({editting}) => editting ? '#F7F7F7' : '#FFFFFF'};
  width: 100%;
  min-height: 38px;
  margin: 0px 0px 10px;
  box-shadow: 0px 2px 10px -6px #252525;
  text-decoration: none;
  border-radius: 15px;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10px;
  justify-content: space-between; 
  align-items: center;
  justify-items: center;
  padding: 7px 12px;

  &:hover {
    background-color: #F7F7F7;
  }
`

export const FormField = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0px;
  margin: 0px;
`

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
`

export const InfoText = styled.p`
  font-size: 14px;
  line-height: 16px;
  text-align: center;
  color: #000000;
  margin: 0px;
`

export const SubTitle = styled(InfoText)`
  font-weight: bold;
`

export const WarningText = styled(InfoText)`
  color: #FF3939;
`

export const Button = styled(LookButton).attrs({ type: 'button' }).attrs(iconButtonLook())`
  width: 32px;
  height: 32px;
`

export const Input = styled(BaseInput)`
  width: 100%;
`

export const MoneyTextMask = styled(NumericFormat).attrs (props => ({
  value: props.value.toFixed (2).replace ('.', ','),
  thousandSeparator: '.',
  decimalSeparator: ',',
  displayType: 'text',
  prefix: 'R$ '
}))`
  color: ${({value}) => parseFloat (value.replace (',', '.')) >= 0 ? '#44CF6C' : '#FF3939'};
  font-size: 16px;
  font-weight: bold;
  line-height: 14px;
  margin-bottom: 0px;
  padding: 0px;
`
